import type { HarnessActionChange } from '@erp/shared-types';

function formatValue(value: unknown): string {
  if (value === null || value === undefined || value === '') return '—';
  if (typeof value === 'number') return value.toLocaleString();
  if (typeof value === 'string' || typeof value === 'boolean')
    return String(value);
  try {
    return JSON.stringify(value);
  } catch {
    return '—';
  }
}

/** Per-field before → after lines shared by the change and preview cards. */
export function NamiChangeList({
  changes,
}: {
  changes: HarnessActionChange[];
}) {
  if (changes.length === 0) return null;
  return (
    <ul className="space-y-0.5">
      {changes.map((change) => (
        <li
          key={`${change.label}|${String(change.before)}|${String(change.after)}`}
          className="text-xs text-muted-foreground"
        >
          <span className="font-medium text-foreground">{change.label}</span>
          {': '}
          {change.before !== undefined ? (
            <>
              <span className="line-through">{formatValue(change.before)}</span>{' '}
              →{' '}
            </>
          ) : null}
          <span>{formatValue(change.after)}</span>
        </li>
      ))}
    </ul>
  );
}
